<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
});

const emit = defineEmits(['search']);

const { t } = useI18n();
const query = ref(props.modelValue);
let debounceTimeout = null;

watch(query, value => {
  clearTimeout(debounceTimeout);
  debounceTimeout = setTimeout(() => {
    emit('search', value.trim());
  }, 400);
});

const clearQuery = () => {
  query.value = '';
};
</script>

<template>
  <div class="px-3 py-2">
    <Input
      v-model="query"
      type="text"
      size="sm"
      :placeholder="t('CHAT_LIST.SEARCH_PLACEHOLDER')"
      :custom-input-class="[
        '[&:not(.focus)]:!border-transparent bg-n-alpha-2 dark:bg-n-solid-1 ltr:!pl-8 rtl:!pr-8',
        query ? 'ltr:!pr-8 rtl:!pl-8' : '',
      ]"
      class="w-full"
    >
      <template #prefix>
        <Icon
          icon="i-lucide-search"
          class="absolute -translate-y-1/2 pointer-events-none text-n-slate-11 size-3.5 top-1/2 ltr:left-2 rtl:right-2"
        />
        <button
          v-if="query"
          type="button"
          class="absolute -translate-y-1/2 text-n-slate-11 size-3.5 top-1/2 ltr:right-2 rtl:left-2"
          @click="clearQuery"
        >
          <Icon icon="i-lucide-x" class="size-3.5" />
        </button>
      </template>
    </Input>
  </div>
</template>
